import { nbsp } from "./typography";
import memoize from "lodash-es/memoize";

export const nonBreakingSpaces = memoize(str => str.split(` `).join(nbsp));
